var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewZealand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#071b65",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.5 9.77V12h4V9.77L12.54 12H15v-1.24L11.24 8H15V4h-2.74L15 2V0h-1.44L9.5 2.98V0h-4v2.8L1.75 0H0v1.9L2.99 4H0v4h3.76L0 10.76V12h2.46z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "m0 1 4.09 3h1.36L0 0zm0 11 5.45-4v1l-4.09 3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "M8.5 12h-2V7H0V5h6.5V0h2v5H15v2H8.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "M15 11.67 10 8v1l4.1 3h.9zM15 0h-.25L9.3 4h1.37L15 .82z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92831",
    d: "m22.5 4.06-.5 1.5h-1.57l1.28.93-.49 1.5 1.28-.93 1.27.92-.49-1.5 1.28-.92h-1.58z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m24 8.31-1.5-1.1-1.52 1.1.58-1.78-1.51-1.1h1.87l.58-1.77.57 1.78h1.87l-1.5 1.1zm-1.5-1.4 1.03.75-.4-1.22 1.04-.75H22.9l-.4-1.22-.4 1.22h-1.27l1.03.75-.4 1.22z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92831",
    d: "m22.5 15.08-.5 1.5h-1.57l1.28.92-.49 1.5 1.28-.93 1.27.93-.49-1.5 1.28-.93h-1.58z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m24 19.33-1.5-1.1-1.52 1.1.58-1.78-1.51-1.1h1.87l.58-1.78.57 1.78h1.87l-1.5 1.1zm-1.5-1.41 1.03.75-.4-1.22 1.04-.75H22.9l-.4-1.22-.4 1.22h-1.27l1.03.75-.4 1.22z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92831",
    d: "m26.5 8.77-.39 1.21h-1.27l1.03.75-.4 1.2 1.03-.74 1.03.75-.4-1.21 1.04-.75H26.9z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m27.77 12.27-1.27-.92-1.26.92.48-1.5-1.27-.91h1.57l.48-1.49.48 1.49h1.57l-1.27.92zm-1.27-1.23.8.57-.3-.93.78-.57h-.98l-.3-.93-.3.93h-.98l.8.57-.3.93z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92831",
    d: "m18.77 9.42-.4 1.2h-1.26l1.02.75-.39 1.21 1.03-.75 1.03.75-.4-1.2 1.03-.76h-1.27z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m20.04 12.9-1.27-.9-1.27.92.49-1.49-1.27-.92h1.56l.49-1.49.48 1.49h1.57l-1.27.92zm-1.27-1.22.79.57-.3-.93.79-.57h-.98l-.3-.93-.3.93h-.98l.79.57-.3.93z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewZealand);
export default __webpack_public_path__ + "static/media/new-zealand.2515eeb4d32a2fe8ef22eec5917fdb3a.svg";
export { ForwardRef as ReactComponent };